// extracted by mini-css-extract-plugin
module.exports = {"draftUpdatedTimestamp":"draftUpdatedTimestamp--18pbw"};